import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/feature/SchemaOrg';
import RankingTable from '@/components/base/RankingTable';
import ArticleCard from '@/components/base/ArticleCard';
import { actresses } from '@/mocks/actresses';
import { categories } from '@/mocks/categories';
import { articles } from '@/mocks/articles';

export default function Home() {
  const top10 = actresses.slice(0, 10);
  const latestArticles = articles.slice(0, 3);

  return (
    <>
      <SchemaOrg type="Organization" data={{
        name: '女优排行榜',
        url: 'https://readdy.ai',
        description: '2025最新权威女优排名平台，汇聚演技实力、票房成绩、粉丝热度等多维度数据。',
        address: { '@type': 'PostalAddress', addressCountry: 'JP', addressLocality: 'Tokyo' },
        contactPoint: { '@type': 'ContactPoint', contactType: 'customer service', email: 'info@ranking.example.com' },
      }} />
      <SchemaOrg type="WebSite" data={{
        name: '女优排行榜',
        url: 'https://readdy.ai',
        description: '2025最新权威女优排名平台',
        potentialAction: { '@type': 'SearchAction', target: 'https://readdy.ai/search?q={search_term_string}', 'query-input': 'required name=search_term_string' },
      }} />
      <SchemaOrg type="WebPage" data={{
        name: '女优排行榜 - 首页',
        url: 'https://readdy.ai',
        description: '女优排行榜为您汇聚2025年最受关注的女优综合评分与人气排名。',
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
            <div className="absolute inset-0">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20abstract%20composition%20with%20warm%20golden%20amber%20and%20soft%20cream%20gradients%2C%20luxurious%20theatrical%20atmosphere%2C%20subtle%20sparkle%20effects%2C%20sophisticated%20minimalist%20design%2C%20warm%20ambient%20glow%2C%20premium%20editorial%20background%2C%20rich%20textures%2C%20no%20people%2C%20cinematic%20mood&width=1800&height=900&seq=hero-bg-2025&orientation=landscape"
                alt="女优排行榜 Hero"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
            </div>
            <div className="relative z-10 text-center px-4 w-full max-w-3xl mx-auto">
              <div className="flex items-center justify-center gap-2 mb-4">
                <div className="w-12 h-12 flex items-center justify-center">
                  <i className="ri-trophy-line text-3xl text-primary-400"></i>
                </div>
              </div>
              <h1 className="text-3xl md:text-5xl font-heading text-white font-bold mb-4 tracking-wide">
                女优排行榜
              </h1>
              <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
                2025最新权威女优排名平台 · 演技实力 · 票房成绩 · 粉丝热度
              </p>
              <div className="flex items-center justify-center gap-3 flex-wrap">
                <Link
                  to="/category/comprehensive"
                  className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  查看综合排行
                </Link>
                <Link
                  to="/about"
                  className="px-6 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full font-medium text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  了解更多
                </Link>
              </div>
            </div>
          </section>

          {/* Stats Bar */}
          <section className="w-full px-4 md:px-6 -mt-10 relative z-20">
            <div className="max-w-4xl mx-auto bg-background-50 rounded-lg border border-background-200/70 p-6 grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                { label: '收录女优', value: '200+', icon: 'ri-user-star-line' },
                { label: '评分维度', value: '5项', icon: 'ri-bar-chart-line' },
                { label: '月度更新', value: '4次', icon: 'ri-refresh-line' },
                { label: '数据来源', value: '10+平台', icon: 'ri-database-2-line' },
              ].map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="w-8 h-8 mx-auto mb-2 flex items-center justify-center text-primary-500">
                    <i className={`${stat.icon} text-xl`}></i>
                  </div>
                  <p className="text-xl font-bold text-foreground-950 font-heading">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Top 10 Ranking */}
          <section className="w-full px-4 md:px-6 py-14 md:py-20">
            <div className="max-w-6xl mx-auto" id="ranking-categories">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 font-bold mb-3">
                  综合实力 TOP 10
                </h2>
                <p className="text-sm text-foreground-600 max-w-lg mx-auto">
                  综合演技实力、票房成绩、粉丝热度等多维度数据，呈现2025年最权威的女优综合排名
                </p>
              </div>
              <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                <RankingTable actresses={top10} scoreKey="overallScore" />
              </div>
              <div className="text-center mt-6">
                <Link
                  to="/category/comprehensive"
                  className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer"
                >
                  查看完整排行榜
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </Link>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 font-bold mb-3">
                  多维度排行榜
                </h2>
                <p className="text-sm text-foreground-600 max-w-lg mx-auto">
                  从不同角度审视女优实力，选择你感兴趣的排行维度
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {categories.map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="group bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 hover:border-primary-300 transition-all duration-300 cursor-pointer"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                      <i className={`${cat.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-lg font-heading text-foreground-950 font-bold mb-2">
                      {cat.name}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {cat.description}
                    </p>
                    <div className="flex items-center gap-1 mt-4 text-sm text-primary-600 font-medium">
                      查看排行
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line"></i>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          {/* Latest Articles */}
          <section className="w-full px-4 md:px-6 py-14 md:py-20">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center justify-between mb-10">
                <div>
                  <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 font-bold mb-2">
                    最新文章
                  </h2>
                  <p className="text-sm text-foreground-600">深度解析行业动态与排行趋势</p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
                {latestArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            </div>
          </section>

          {/* FAQ Section */}
          <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 font-bold mb-10 text-center">
                常见问题
              </h2>
              <div className="space-y-3">
                {[
                  { q: '女优排行榜的评分标准是什么？', a: '我们的评分体系涵盖演技实力（占比30%）、票房成绩（占比30%）、粉丝热度（占比25%）和作品质量（占比15%）四个维度，综合计算得出最终排名。' },
                  { q: '排行榜数据多久更新一次？', a: '综合排行榜每月更新一次，人气热度榜每周更新，票房成绩榜每季度更新。特殊档期（如夏季大战）会有额外更新。' },
                  { q: '新人推荐榜的入选标准是什么？', a: '新人推荐榜收录2023年及以后出道的女优，评选标准包括出道作品质量、社交媒体热度增长、行业评价等多个维度。' },
                  { q: '如何保证排名数据的客观公正？', a: '我们采用多平台交叉验证的数据采集方式，所有数据均来自公开可查的销售平台、社交媒体和行业报告，确保排名的客观性和权威性。' },
                ].map((faq, idx) => (
                  <details key={idx} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100/50 transition-colors">
                      <span className="text-sm font-medium text-foreground-950 pr-4">{faq.q}</span>
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform">
                        <i className="ri-arrow-down-s-line"></i>
                      </div>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          <SchemaOrg type="FAQPage" data={{
            mainEntity: [
              { '@type': 'Question', name: '女优排行榜的评分标准是什么？', acceptedAnswer: { '@type': 'Answer', text: '我们的评分体系涵盖演技实力（占比30%）、票房成绩（占比30%）、粉丝热度（占比25%）和作品质量（占比15%）四个维度，综合计算得出最终排名。' } },
              { '@type': 'Question', name: '排行榜数据多久更新一次？', acceptedAnswer: { '@type': 'Answer', text: '综合排行榜每月更新一次，人气热度榜每周更新，票房成绩榜每季度更新。特殊档期（如夏季大战）会有额外更新。' } },
              { '@type': 'Question', name: '新人推荐榜的入选标准是什么？', acceptedAnswer: { '@type': 'Answer', text: '新人推荐榜收录2023年及以后出道的女优，评选标准包括出道作品质量、社交媒体热度增长、行业评价等多个维度。' } },
              { '@type': 'Question', name: '如何保证排名数据的客观公正？', acceptedAnswer: { '@type': 'Answer', text: '我们采用多平台交叉验证的数据采集方式，所有数据均来自公开可查的销售平台、社交媒体和行业报告，确保排名的客观性和权威性。' } },
            ],
          }} />
        </main>

        <Footer />
      </div>
    </>
  );
}